// extracted by mini-css-extract-plugin
export default {"Badge":"styles_Badge__YchO3","active":"styles_active__ww73t"};